import styled from 'styled-components'

import { Alert } from 'src/components/Ant'

const WrapAlert = styled(Alert)`
  margin: 12px;
  border-radius: 4px;
`

const WrapTable = styled.div`
  margin: 12px;
  border-radius: 4px;
`

export { WrapAlert, WrapTable }
